import { DisputesEdge } from '@varo/graphql-schema-types';
import useDisputesTransactionsList from 'features/myVaro/hooks/disputes/useDisputesTransactionsList';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlatList, StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';
import { formatDate } from 'shared/utils/string/date';

interface TransactionData {
  disputesData: DisputesEdge;
}
const DisputesTransactionsList = ({ disputesData }: TransactionData) => {
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'disputes',
  });

  const { loadMoreRecords, pageInfo, filteredTransactionsList, loading } =
    useDisputesTransactionsList(disputesData);

  return (
    <View>
      <FlatList
        data={filteredTransactionsList}
        renderItem={({ item }) => (
          <View key={item?.node?.id}>
            <ListItem
              showsChevron={false}
              primaryCopy={item?.node?.description}
              secondaryCopy={
                item?.node?.createdAt
                  ? formatDate(item.node.createdAt, 'MMMM d, yyyy')
                  : null
              }
              trailingAccessory={{
                id: item?.node?.value?.formattedWithPlusPrefix,
                name: VXLComponentId.LIST_ITEM_TEXT_STACK,
                props: {
                  primaryCopy: item?.node?.value?.formatted,
                },
              }}
            />
          </View>
        )}
        ItemSeparatorComponent={() => (
          <View style={styles.paddingHorizontal}>
            <HairLineDivider />
          </View>
        )}
        keyExtractor={(item) => item?.node?.id}
        removeClippedSubviews={false}
      />
      {pageInfo?.hasNextPage ? (
        <View style={styles.paddingHorizontal}>
          <Button
            label={translatedText('buttons.showMore')}
            onPress={loadMoreRecords}
            size="SMALL"
            type="TEXT"
            width="HUG"
            isLoading={loading}
          />
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  paddingHorizontal: {
    paddingHorizontal: theme.spacing.m,
  },
});

export default DisputesTransactionsList;
